import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { compact } from 'lodash'

import Api from 'services/Api'
import { getAttributeName } from 'services/Utilities'
import { Format } from 'services/Dates'
import { destroy, init } from 'store/actions/tables'
import { createErrorNotification } from 'store/actions/notifications'
import { closeModal } from 'store/actions/modals'
import { removeAttributeReminderToConfirm } from 'store/actions/applicationInfo'
import { Button } from 'components/Forms'
import BaseModal from 'components/Modals/BaseModal'
import { Table } from 'components/UI'
import { Card } from 'ui'

import { t } from 'translations'

const EmployeeAttributeExpirationConfirmationModal = () => {
  const dispatch = useDispatch()
  const { attributeReminderToConfirm: content = [] } = useSelector(state => state.applicationInfo)
  const { defaultTimeZone } = useSelector(state => state.settings)
  const [isSubmitting, setIsSubmitting] = useState()

  useEffect(() => {
    const header = [
      {
        key: 'attributeId',
        label: 'employee.attributeExpiration.ATTRIBUTE',
        type: 'custom',
        render: attributeId => getAttributeName(attributeId)
      },
      { key: 'expirationDate', label: 'employee.attributeExpiration.EXPIRATIONDATE', inFormat: 'date', type: 'date', outFormat: 'humanDate' },
      {
        key: 'events',
        label: 'employee.attributeExpiration.REMINDERDATE',
        type: 'custom',
        render: events => Format(events.delivered, { isUTC: true, timeZone: defaultTimeZone, outFormat: 'humanDateTime' })
      }
    ]
    init('employee-attribute-expiration', compact(header), null, { content, count: content.length || 0, limit: Infinity })
    return () => destroy('employee-attribute-expiration')
  }, [content, defaultTimeZone])

  const confirm = async () => {
    setIsSubmitting(true)
    const attributeRemindersIds = content.map(reminder => reminder._id)
    const { success } = await Api.put('/attributes/contact/events', { attributeRemindersIds })
    if (!success) return dispatch(createErrorNotification())
    setIsSubmitting()
    dispatch(removeAttributeReminderToConfirm())
    dispatch(closeModal())
  }
  return (
    <BaseModal title="employee.attributeExpiration" hideButtons noPadding shouldCloseOnOverlayClick={false} preventClosing>
      <Card maxHeight="40rem" className="mx-3 mb-3 mt-3">
        <Table name="employee-attribute-expiration" />
      </Card>
      <div className="px-3 pb-3">
        <Button className="btn btn-primary mr-2" isSubmitting={isSubmitting} onClick={confirm}>
          {t('employee.attributeExpiration.PRIMARY_ACTION')}
        </Button>
      </div>
    </BaseModal>
  )
}

export default EmployeeAttributeExpirationConfirmationModal
